// removed by extract-text-webpack-plugin
module.exports = {"hoverComponent":"_2H9WNZ9eBexm12HSumVbY1","hoverBefore":"Pp62c7acdB65-H0syI_Pq","hoverAfter":"_1dg1K9igAkq47SzzOMmqil","img_big":"_1hCijYAH1ASItddZ1MID8M","ding_guodu":"_3U8qkEZWWGzg3AWp_5YOcM","img_txt":"XQjQhu5gw_HrxLNz5DcWh"};


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/HoverComponent/HoverComponent.scss
 ** module id = 982
 ** module chunks = 0
 **/